var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movies"},_vm._l((_vm.movies),function(movie){return _c('div',{key:movie.id,staticClass:"block"},[_c('figure',[_c('router-link',{staticClass:"movie-name",attrs:{"to":{name:'MovieDetail',params:{id:movie.id}}}},[_c('img',{attrs:{"src":movie.image}})])],1)])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a434ffd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MovieList.vue
// module id = null
// module chunks = 